import React, { Component } from 'react'
import { FormControl, Select, MenuItem } from '@mui/material'

import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'
class DefFieldImageCodeSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            imageType:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.imageType
                    ? this.props.item.settings.imageType
                    : 'code128',
        }
        this.onChange = this.onChange.bind(this)
    }

    onChange(event) {
        const { name, value } = event.target

        this.props.onChange(name, value)
        this.setState({ [name]: value })
    }

    render() {
        const { kedo } = this.props
        const { imageType } = this.state
        return (
            <div>
                <h3>{this.props.kedo.t('Settings')}</h3>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>{this.props.kedo.t('Type')}</FormInputLabel>
                    <Select
                        value={imageType}
                        name="imageType"
                        onChange={this.onChange}
                        size="small"
                    >
                        <MenuItem value="qrcode">{kedo.t('qrcode')}</MenuItem>
                        <MenuItem value="code128">{kedo.t('code128')}</MenuItem>
                        <MenuItem value="code39">{kedo.t('code39')}</MenuItem>
                    </Select>
                </FormControl>
            </div>
        )
    }
}

export default DefFieldImageCodeSettings
